module.exports = __webpack_public_path__ + "static/assets/b44d8ad52069faa2a22f359d3c07cdf8.png";